<template>
  <!-- 矩阵填空 矩阵星级评分 -->
  <div @click="setEditIndex(index)">
    <el-row :gutter="10" style="margin-left: 5px">
      <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">{{
        number
      }}</el-col>
      <el-col
        :xs="15"
        :sm="15"
        :md="15"
        :lg="15"
        :xl="15"
        class="item_container_title"
      >
        <el-input
          placeholder="请输入题目内容"
          @focus="showAdvance"
          @blur="updateQuestion()"
          v-model="question.questionsName"
          autosize
        ></el-input>
      </el-col>
      <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
        <i
          class="el-icon-delete delete"
          v-if="index == editIndex"
          @click="questiondel(question.id)"
        ></i>
        <el-badge
          v-if="question.displayscriptcount || question.jumpscriptcount"
          :value="question.displayscriptcount + question.jumpscriptcount"
          class="item"
        >
          <i
            class="el-icon-share"
            @click="() => $emit('jumpshow', question.id)"
          ></i>
        </el-badge>
        <i class="el-icon-rank item drag-handle"></i>
      </el-col>
    </el-row>
    <div style="max-width: 1100px; overflow-x: auto">
      <table>
        <tr>
          <th class="td_width"></th>
          <th
            class="td_width"
            style="text-align: center"
            :style="{
              width:
                option.columnWidth + option.columnWidthUnit + ' !important',
            }"
            v-for="(option, index2) in questionsSonList[0].optionList"
            :key="index2"
          >
            <input
              type="text"
              v-model="option.labelName"
              style="width: 130px; height: 30px"
              @blur="wjupdoption(option, 1)"
            />
            <!-- <el-dropdown @command="wjdelquestionoption(questionsSonList[0].optionList, option, index2)">
						<span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
						<el-dropdown-menu slot="dropdown"><el-dropdown-item>删除</el-dropdown-item></el-dropdown-menu>
					</el-dropdown> -->
            <el-dropdown
              @command="
                (c) =>
                  wjdelquestionoption(
                    questionsSonList[0].optionList,
                    option,
                    index2,
                    c
                  )
              "
            >
              <!-- <el-dropdown @command="(c)=>handleCommand(c,questionsSonList[0].optionList, option, index2)"> -->
              <span class="el-dropdown-link"
                ><i class="el-icon-arrow-down el-icon--right"></i
              ></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="删除">删除</el-dropdown-item>
                <!-- <el-dropdown-item command="设置" >设置</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </th>
        </tr>
        <tr v-for="(item, index) in questionsSonList" :key="item.id">
          <td class="td_width">
            <input
              type="text"
              style="width: 130px; height: 30px"
              v-model="item.questionsName"
              @blur="updateQuestion1(item, 1)"
            />
            <el-dropdown @command="questiondel(item.id, question.id)">
              <span class="el-dropdown-link"
                ><i class="el-icon-arrow-down el-icon--right"></i
              ></span>
              <el-dropdown-menu slot="dropdown"
                ><el-dropdown-item>删除</el-dropdown-item></el-dropdown-menu
              >
            </el-dropdown>
          </td>
          <td
            class="td_width"
            style="text-align: center"
            v-for="(option, index2) in questionsSonList[0].optionList"
            :key="index + '-' + index2"
          >
            <ul class="ul_rate" :option="option.id">
              <li
                v-for="(n, index4) in question.most"
                :key="option.id + '-' + index4"
              >
                <img :src="darkStar" alt="" />
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </div>
    <el-row
      :gutter="10"
      style="margin-top: 12px !important"
      v-if="index == editIndex"
    >
      <el-col
        :xs="16"
        :sm="16"
        :md="16"
        :lg="16"
        :xl="16"
        class="el_item_option item_container_title"
        style="margin-left: 50px"
      >
        <i
          class="el-icon-plus el-icon-common"
          @click="wjaddquestionoption(question.optionList, question, 0)"
          >添加行</i
        >
        <i
          class="el-icon-plus el-icon-common"
          @click="
            addmatrixquestionsoption(questionsSonList[0].optionList, question)
          "
          >添加列</i
        >
        <i
          class="el-icon-plus el-icon-common"
          @click="batchAdd(question.optionList, question, 11)"
          >批量添加行</i
        >
        <i
          class="el-icon-plus el-icon-common"
          @click="batchAdd(question.optionList, question, 22)"
          >批量添加列</i
        >
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      questionsSonList: [],
      darkStar: require('@/assets/default-imgs/stars_2.png'), //暗星星
      jz: "jz",
    };
  },
  props: {
    number: { type: Number, default: 0 },
    question: {},
    editIndex: { type: Number, default: 0 },
    index: { type: Number, default: 0 },
    isExistPage: { type: Boolean, default: false },
    editOptionIndex: { type: String, default: "0_0" },
  },
  onShow() {},
  methods: {
    batchAdd(options, item, ifRow) {
      this.$emit("batchAdd", options, item, this.jz, this.question.id, ifRow);
    },
    wjupdoption(item, status) {
      this.$emit("wjupdoption", item, status);
    },
    updateQuestion() {
      this.$emit("wjupdquestionoption", this.question);
    },
    updateQuestion1(question, status) {
      this.$emit("wjupdquestionoption", question, status);
    },
    //添加自题目
    wjaddquestionoption() {
      //this.question.questionsSonList.push({});
      this.$emit("addquestionitem", this.question);
    },
    showAdvance(e) {
      this.$emit("showAdvance", e);
    },
    setEditIndex(index) {
      this.$emit("setEditIndex", index);
    },
    setEditOptionIndex(childIndex) {
      this.$emit("setEditOptionIndex", childIndex);
    },
    // wjdelquestionoption(options, item, childindex) {
    // 	this.$emit('wjdelquestionoption', options, item, childindex);
    // },
    wjdelquestionoption(options, item, childindex, command) {
      if (command == "删除") {
        this.$emit("wjdelquestionoption", options, item, childindex);
      }
      if (command == "设置") {
        this.$emit(
          "wjsetquestionoption",
          options,
          item,
          childindex,
          this.jz,
          this.question.id
        );
      }
    },
    addmatrixquestionsoption(optionList, question) {
      this.$emit("addmatrixquestionsoption", optionList, question);
    },
    questiondel(id, pid) {
      this.$emit("questiondel", id, pid);
    },
  },
  created() {
    //console.log(JSON.stringify(this.question))
    let that = this;
    that.questionsSonList = this.question.questionsSonList;
  },
};
</script>

<style scoped>
.ul_rate {
  display: flex;
  justify-content: space-around;
}
/deep/ .textval {
  border: 1px solid #ccc !important;
  width: 130px;
  height: 20px;
  margin: 0 auto;
}
table,
table td,
table th {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin-left: 45px;
  margin-bottom: 20px;
  margin-top: 10px;
}
tr {
  height: 30px;
}
.td_width {
  width: 150px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.delete,
.item {
  font-size: 22px !important;
  line-height: 40px !important;
  margin-right: 30px !important;
  text-align: right;
  float: right;
  cursor: pointer;
}
.item .el-badge__content.is-fixed {
  top: 10px;
}
.item.drag-handle {
  cursor: move;
}
.el_item_option {
  line-height: 40px;
  height: 44px;
}

.el-icon-common {
  margin-right: 23px;
  font-size: 16px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.el-icon-common-option {
  margin-left: 10px;
  font-size: 22px !important;
  line-height: 40px !important;
  color: cornflowerblue;
  cursor: pointer;
}

.askxh {
  line-height: 40px;
  text-align: right;
}

.item_container_title {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.item_container_title:hover {
  //border: 1px darkgrey dashed;
}
</style>
